import React, { useMemo } from 'react';
import { ReactNode, useState } from 'react';
import { bottomContainer, menuContainer, menuIconContainer, menuLabel, siteTitleContainer, subMenucontainer } from './styles';
import MenuIcon from './components/MenuIcon';
import { StaticImage } from 'gatsby-plugin-image';
import { Navigation } from './content';
import settings from '@settings';
import { useColorStore } from '@provider';
import { Link, navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import { motion } from 'framer-motion';
import { FlexBox } from '@ui';

const Framework = ({children}: {children: ReactNode}) => {
	const [showMenu, setShowMenu] = useState(false);
	const location = useLocation();
	const {leftContentColor, rightContentColor} = useColorStore();

	const renderLogo = useMemo(() => {
		if (leftContentColor === 'dark') {
			return <StaticImage height={24} src={'./images/patwork_logo.png'} alt='Patflow' />
		} else {
			return <StaticImage height={24} src={'./images/patwork_logo_white.png'} alt='Patwork' />
		}
	}, [location, leftContentColor])

	const menuItems: {link?: string, label: string, onClick?: () => void}[] = useMemo(() => {
		const menuArray = [
			{
				link: '/projekte/',
				label: 'Projekte',
			},
			{
				link: '/focus/',
				label: 'Fokus',
			},
			{
				link: '/kontakt/',
				label: 'Kontakt',
			}
		]

		return menuArray;
	}, [location])

	return (
		<>
			<motion.div 
				css={menuContainer} 
			>
				<div css={siteTitleContainer}>
					<div css={{cursor: 'pointer'}} onClick={() =>  navigate('/')}>{renderLogo}</div>
				</div>	
				
				<motion.div 
					css={[subMenucontainer]}
				>
					{menuItems.map(menuItem => (
						<motion.div
							key={menuItem.link}
							// whileHover={{borderBottom: '2px solid ' + settings.colors.dark}}
							animate={location.pathname === menuItem.link ? {opacity: 0.5, fontWeight: 700} : {opacity: 1, fontWeight: 700}}
							transition={{duration: 0.5, ease: 'easeOut'}}
							css={[menuLabel, {cursor: 'pointer', color: rightContentColor === 'dark' ? settings.colors.dark : settings.colors.light}]}
							onClick={() => {
								if (menuItem.onClick) {
									menuItem.onClick()
								} else if (menuItem.link) {
									navigate(menuItem.link)
								}
							}}
						>
							{menuItem.label}
						</motion.div>
					))}
				</motion.div>
					<div css={settings.mq({width:'30px', display: ['block', 'none']})} />
				</motion.div>

				<div css={bottomContainer}>
					<p color='' css={{color: leftContentColor === 'dark' ? settings.colors.dark : settings.colors.light}}>
						@ {new Date().getFullYear()} 
					</p>
					<FlexBox direction='row' gap={settings.sizes.medium}>
						<Link to='/impressum/' css={{color: rightContentColor === 'dark' ? settings.colors.dark : settings.colors.light}}>
							Impressum
						</Link>
						<Link to='/datenschutz/' css={{color: rightContentColor === 'dark' ? settings.colors.dark : settings.colors.light}}>
							Datenschutz
						</Link>
					</FlexBox>

				</div>
				<div css={menuIconContainer}>
					<div css={menuLabel}>
						MENU
					</div>
					<MenuIcon showMenu={showMenu} setShowMenu={setShowMenu} color={settings.colors.dark} />
				</div>
					<Navigation showMenu={showMenu} setShowMenu={setShowMenu}  />
			{children}
		</>
	);
};

export default Framework;